import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import EditEntryPage from '../components/entries/EditEntryPage';
import AddEntryPage from '../components/entries/AddEntryPage';
import CashierPage from '../components/entries/CashierPage';
import HelpPage from '../components/help/HelpPage';
import DashboardPage from '../components/home/DashBoardPage';
import NotFoundPage from '../components/NotFoundPage';
import AdminPage from '../components/admin/AdminPage';
import AddExpenseAccountPage from '../components/admin/expenseAccounts/AddExpenseAccountPage';
import EditExpenseAccountPage from '../components/admin/expenseAccounts/EditExpenseAccountPage';
import AddVendorPage from '../components/admin/vendors/AddVendorPage';
import EditVendorPage from '../components/admin/vendors/EditVendorPage';
import LoginPage from '../components/auth/LoginPage';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import AdminRoute from './AdminRoute';

export const history = createHistory();

const AppRouter = () => (
  <Router history={history}>
    <Switch>
      <PublicRoute
        exact
        path="/"
        component={LoginPage}
      />
      <PrivateRoute
        path="/dashboard"
        component={DashboardPage}
      />
      <PrivateRoute
        path="/cashier"
        component={
          CashierPage
        }
      />
      <PrivateRoute
        path="/create"
        component={
          AddEntryPage
        }
      />
      <PrivateRoute
        path="/edit/:id"
        component={
          EditEntryPage
        }
      />
      <PrivateRoute
        path="/help"
        component={
          HelpPage
        }
      />
      <Switch>
    <AdminRoute
      exact
      path="/admin"
      component={
        AdminPage
      }
    />
    <AdminRoute
      path="/admin/add-vendors"
      component={
        AddVendorPage
      }
    />
    <AdminRoute
      path="/admin/edit-vendors"
      component={
        EditVendorPage
      }
    />
    <AdminRoute
      path="/admin/add-expense-accounts"
      component={
        AddExpenseAccountPage
      }
    />
    <AdminRoute
      path="/admin/edit-expense-accounts"
      component={
        EditExpenseAccountPage
      }
    />
    <PrivateRoute
      component={
        NotFoundPage
      }
    />
    </Switch>


    </Switch>
  </Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js